export const TOGGLE_MODAL = "TOGGLE_MODAL";
export const GET_NOTIFICATIONS_LIST = "GET_NOTIFICATIONS_LIST";
export const ADD_ITEM_TO_LIST = "ADD_ITEM_TO_LIST";
export const GET_REQUEST = "GET_REQUEST";
export const REQUEST_NOTIFICATION_LIST = "REQUEST_NOTIFICATION_LIST"
export const UPDATE_READED_NOTIFICATIONS = "UPDATE_READED_NOTIFICATIONS";